// extracted by css-extract-rspack-plugin
export default {"Label":"s3mSqZIUe8Eh6jfN","bold":"y1NeOjdpwJwtP0Hv"};